<template>
    <div class="pe-teams mb-4">
        <div v-for="team in editor.teams" :key="team.key" class="pe-team ui-card" :class="{ 'pe-team--active': team.key === editor.activeTeamKey }" :style="{ borderTopColor: team.color }"
            @click="editor.activeTeamKey = team.key">
            <div class="pe-team__head">
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <button type="button" class="pe-team__color" :style="{ background: team.color }" aria-label="Cor da equipe" v-bind="attrs" v-on="on" @click.stop></button>
                    </template>
                    <div class="pe-palette">
                        <button v-for="color in editor.palette" :key="color" type="button" class="pe-team__color" :style="{ background: color }" :aria-label="`Usar a cor ${color}`" @click="editor.setColor(team, color)"></button>
                    </div>
                </v-menu>
                <input v-model="team.name" class="pe-team__name" maxlength="80" aria-label="Nome da equipe" @input="editor.queueSave" @click.stop>
                <span v-if="team.key === editor.activeTeamKey" class="pe-team__active">recebe os novos casos</span>
                <ui-action-menu icon-only small label="Ações da equipe" :items="editor.teamActions(team)" />
            </div>
            <v-select v-model="team.member_ids" :items="editor.memberItems" label="Responsáveis (vão nas agendas)" multiple small-chips dense outlined hide-details
                :menu-props="{ offsetY: true }" class="mt-2" @change="editor.queueSave" @click.native.stop></v-select>
            <div class="pe-team__totals">
                <template v-if="editor.planOf(team)">
                    <span><strong>{{ editor.planOf(team).totals.cases }}</strong> {{ editor.planOf(team).totals.cases === 1 ? "caso" : "casos" }}</span>
                    <span>{{ editor.planOf(team).totals.estimated ? "≈ " : "" }}{{ editor.planOf(team).totals.km.toLocaleString("pt-BR") }} km</span>
                    <span>{{ editor.planOf(team).totals.days }} {{ editor.planOf(team).totals.days === 1 ? "dia" : "dias" }}</span>
                    <span>{{ editor.formatHoursText(editor.planOf(team).totals.hours) }} de estrada</span>
                    <span v-if="editor.planOf(team).totals.warnings" class="pe-warn">{{ editor.planOf(team).totals.warnings }} {{ editor.planOf(team).totals.warnings === 1 ? "aviso" : "avisos" }}</span>
                </template>
                <span v-else-if="editor.errorOf(team)" class="pe-error">{{ editor.errorOf(team) }}</span>
                <span v-else class="ui-muted">{{ editor.countOf(team) ? "Calculando…" : "Sem casos. Selecione a equipe e inclua pelo mapa ou pela lista." }}</span>
            </div>
        </div>
        <div class="pe-teams__add">
            <v-btn outlined small :disabled="editor.teams.length >= 8" @click="editor.addTeam"><v-icon left small>mdi-plus</v-icon>Equipe</v-btn>
            <v-btn outlined small :disabled="!editor.form.base_id || !editor.stops.length" @click="editor.openSplit"><v-icon left small>mdi-call-split</v-icon>Dividir entre equipes</v-btn>
        </div>
    </div>
</template>

<script>
// Editor de roteiro: Cartões das equipes (cor, nome, responsáveis e totais) e as ações de incluir ou dividir equipes.
// O estado e os metodos ficam no ProspectTripEditor (inject "editor").
export default {
    name: "ProspectTripTeams",
    inject: ["editor"],
};
</script>
